import React from "react";

/**
 * Tiny, non-interactive Venmo indicator.
 * Renders only when username is present; does NOT display the username.
 */
export default function VenmoBadge({ username, className = "", title = "Venmo" }) {
  if (!username || !String(username).trim()) return null;

  return (
    <span className={`as-venmo-badge ${className}`.trim()} title={title} aria-hidden="true">
      V
    </span>
  );
}

